import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import LoadSpeakers from '../loaders/LoadSpeakers';
import EventSpeakerProfile from '../screens/EventSpeakers/EventSpeakerProfile';
import EventSpeakers from '../screens/EventSpeakers/EventSpeakers';
import InviteToMeetingScreen from '../screens/Meetings/InviteToMeetingScreen';
import directoryRoutes, { childDirectoryRoutes } from './directoryRoutes';
import ScheduleItemRoutes from './scheduleRoutes/scheduleItemRoutes';
import RelativeRedirect from '../elements/RelativeRedirect';

export const SingleSpeakerRoutes = (props) => {
    return (
        <Switch>
            <Route path={`${props.match.path}/directory`} component={childDirectoryRoutes} />
            <Route path={`${props.match.path}/invite`} exact component={InviteToMeetingScreen} />
            <RelativeRedirect from={`${props.match.path}/program`} exact to={'..'} />
            <Route path={`${props.match.path}/program/:itemId`} component={ScheduleItemRoutes} />
            <Route path={`${props.match.path}`} exact component={EventSpeakerProfile} />
            <Redirect to={`..`} />
        </Switch>
    );
};

export default (props) => (
    <LoadSpeakers {...props.match.params}>
        <Switch>
            <Route path={`${props.match.path}/:speakerId/invite`} component={InviteToMeetingScreen} />
            <Route path={`${props.match.path}/:speakerId`} component={SingleSpeakerRoutes} />
            <Route path={`${props.match.path}`} exact component={EventSpeakers} />
            <Redirect to={`${props.match.path}`} />
        </Switch>
    </LoadSpeakers>
);
